import React from "react";
import { useTranslation } from "react-i18next";
import ModalContainer from "../../containers/Modal/ModalContainer";
import { useInterviewContext } from "./InterviewContext";

const ModalAlertExistInterview = ({ showModal, setShowModal, message }) => {
  const { t } = useTranslation();

  const {
    setTabActive,
    setLastInterviewInTheContext
  } = useInterviewContext();

  return (
    <ModalContainer
      modalTitle={t("Alert")}
      isOpen={showModal}
      submitButtonAction={() => {
        setLastInterviewInTheContext();
        setShowModal(false);
      }}
      submitButtonTitle={t("Confirm")}
      submitButtonType="button"
      cancelButtonAction={() => {
        setTabActive(0);
        setShowModal(false);
      }}
      cancelButtonTitle={t("Cancel")}
    >
      {message}
    </ModalContainer>
  );
};

export default ModalAlertExistInterview;
